import Global from '../scripts/Global'
import { serverBus } from '../main'
import UserApi from '../scripts/api/user.api'
import SessionManager from '../Manager/Session.manager'
import MainNotification from '../Manager/Notification/main.manager'
import MainApi from '../scripts/api/main.api'
import PushNotification from '../scripts/serviceWorker/serviceWorker'

import VueSignals from '../scripts/VueSignals';
import { User } from '../classes/User';
import ChannelApi from '../scripts/api/channel.api';

export default {
    name: 'GlobalSignaling',
    template: '<template><div></div></template>',
    data (){
      return {
        loggedInUser: null,
        active_channel: SessionManager.getActiveChannel(),
      }
    },
    created(){
      MainApi.onLoad()
    },
    mounted(){
      // PushNotification.register()
        /**Login */
        UserApi.LoggedInUserData().then(
          res => {
            if(res && res.data.result){
              if(!res || !res.data.result && res.data.reason == "session_id_invalid"){
                Global.setSessionInvalid(true)
              }else{
                Global.setSessionInvalid(false)
              }
              SessionManager.setLoggedInUser(res.data)
              /** WebRTC related */
              if(res.data.ongoing_channel_call_id && res.data.ongoing_channel_call_id.length > 0){
                Global.globalValue("ongoing_channel_call_id", res.data.ongoing_channel_call_id)
              }
              /** end WebRTC related */
              let Invitations = res.data.invitations
              SessionManager.CreatePublishedInvitation(res.data.published_invitations)
              SessionManager.setInvitations(Invitations)
              this.$forceUpdate();
              /****************** Check in invitations **********************/
              // TODO(Alex): this set the invitations channels name wrong
              // On this part, channels haven't been loaded
              // if(typeof Invitations != 'undefined' && Invitations.length > 0){
              //   for(let invit in Invitations){
              //     let channel = Invitations[invit]
              //     if(typeof Invitations[invit].folder_cp_id != "undefined" && Invitations[invit].folder_cp_id.length >0){
              //       ChannelApi.channelDetails(Invitations[invit].folder_cp_id).then(res=> {
              //           console.log('channelDetails', res);
              //         if(res.data.result){
              //           channel = {...channel, ...res.data.channel}
              //         }
              //         console.log('CHANNELLLLLL!!!', channel);
              //         SessionManager.createChannel(channel)
              //       })
              //     }
              //   }
              // }
            }else {
              Global.logout()
              Global.removeAllCookies()
            }
          }).then(res => {
              Global.globalValue(VueSignals.BUS_LOGGEDIN_ARRIVED, true)
          })

          serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (success) => {
            this.active_channel = SessionManager.getActiveChannel()
          })


          /**
           *  force reloading UI for loggedin sessions
          */
          serverBus.$on(VueSignals.SOCKET_REFRESH_UI, (data) => {
            if(data.event == VueSignals.SOCKET_REFRESH_UI){
              location.reload()
            }
          })


          /**
           *  handle web socket notifocation
          */
        serverBus.$on(VueSignals.SOCKET_USER_JOIN_CHANNEL, (data) => {
          if(data.event == VueSignals.SOCKET_USER_JOIN_CHANNEL  &&
            this.active_channel.channel_id == data.channel_id) {
              if(SessionManager.getLoggedInUser().user_id != data.user.user_id){
                  SessionManager.addUsertoChannel(data.channel_id, data.user)
                MainNotification.push(this.$t("has Joined the channel", {user: data.user.username}))
              }
          }
        });

      /**
       *  Notification currChannel purpose edited
       */
        serverBus.$on(VueSignals.SOCKET_CHANNEL_EDIT, (data) => {
          if(data.event == VueSignals.SOCKET_CHANNEL_EDIT  &&
            this.active_channel.channel_id == data.channel_id) {
              SessionManager.UpdateChannel(this.active_channel.channel_id, {"channel_purpose": data.purpose})
          }
        });

        serverBus.$on(VueSignals.SOCKET_USER_LEFT_CHANNEL, (data) => {
          if(data.event == VueSignals.SOCKET_USER_LEFT_CHANNEL  &&
            this.active_channel.channel_id == data.channel_id) {
              SessionManager.RemoveUserFromChannel(this.active_channel.channel_id, data.origin.user_id)
              if(data.origin.user_id != SessionManager.getLoggedInUserId()){
                MainNotification.push(this.$t("has left the channel", {user: SessionManager.getUser(data.origin.user_id).username}));
              }
          }
        });



        serverBus.$on(VueSignals.SOCKET_CHANNEL_DELETED, (data) => {
          if(typeof data.channel_id != 'undefined'){
            SessionManager.removeChannel(data.channel_id)
          }
        })


        serverBus.$on(VueSignals.SOCKET_CHANNEL_RENEAMED, (data) => {
          if(data.event == VueSignals.SOCKET_CHANNEL_RENEAMED) {
            SessionManager.UpdateChannel(data.channel_id, {"channel_name":data.new_name})
          }
        })





        // users  reachability status
        serverBus.$on(VueSignals.SOCKET_USER_STATUS_CHANGED, (message_data) => {
          if(typeof message_data.data.status != "undefined"){
            SessionManager.UpdateUserReachability(message_data.origin.user_id, message_data.data.status)
            SessionManager.UpdateDirectMessageReachability(message_data.origin.user_id, message_data.data.status)
          }
        })


          /**
            *  @channel purpose edited
            */
          serverBus.$on(VueSignals.SOCKET_CHANNEL_PURPOSE_EDIT, (data) => {
            if(data.event == VueSignals.SOCKET_CHANNEL_PURPOSE_EDIT &&
              data.channel_id == SessionManager.getActiveChannelId()){
                SessionManager.UpdateChannel(data.channel_id, {
                  "channel_purpose": data.channel_purpose
                })
            }
          })


        /**user for direct messages creation  */
        serverBus.$on(VueSignals.SOCKET_USER_CREATED, (data) => {
          if(data.event == VueSignals.SOCKET_USER_CREATED) {
            SessionManager.createUser(data.user_doc)
          }
        })

        serverBus.$on(VueSignals.SOCKET_CHANNEL_CHANGED, (data) => {
          if(data.event == VueSignals.SOCKET_CHANNEL_CHANGED) {
              SessionManager.UpdateChannel(data.channel_doc.channel_id, data.channel_doc)
              if (!data.channel_doc.direct) {
                  // Sometimes the picture changed
                  ChannelApi.channelDetails(data.channel_doc.channel_id).then(response => {
                      if (response.data.result) {
                          let data = response.data.channel;
                          let image_doc = '';
                          if(data.image_doc != null && typeof data.image_doc.valueb64 != 'undefined'){
                              image_doc = "data"+data.image_doc.mimetype+";base64," + data.image_doc.valueb64
                              if(data.image_doc.mimetype.indexOf(":")== -1){
                                  image_doc = "data:"+data.image_doc.mimetype+";base64," + data.image_doc.valueb64
                              }
                          }
                          SessionManager.UpdateChannelPicture(data.channel_id, image_doc);
                      }
                  });
              }
          }
        })

        /**channel_created for direct messages creation  */
        serverBus.$on(VueSignals.SOCKET_CHANNEL_CREATED, (data) => {
          if(data.event == VueSignals.SOCKET_CHANNEL_CREATED) {
            // draft channel
            if(data.channel_doc.direct && data.channel_doc.user_ids[0] == data.channel_doc.user_ids[1]){
              if(SessionManager.getActiveChannel().type == "draft"){
                SessionManager.setActiveChannel(SessionManager.createChannel(data.channel_doc))
              }
              return
            }

            if(data.channel_doc.direct && typeof data.external_email != 'undefined'){
              data.channel_doc.channel_name =  data.external_email
              data.channel_doc.external = true
            }
            SessionManager.addUsertoChannel(data.channel_doc.channel_id, new User({
              "pending": true,
              "email": data.external_email
            }))
            SessionManager.createChannel(data.channel_doc)

            for(let i=0; i < data.channel_doc.user_ids.length;i++){
              if(data.channel_doc.user_ids[i] != SessionManager.getLoggedInUserId()){
                let newUser = SessionManager.getUser(data.channel_doc.user_ids[i])

                if (newUser.isEmpty()) {
                    // Search for the user with the api
                    UserApi.getUsers([data.channel_doc.user_ids[i]]).then(res => {
                        if (res.data.result) {
                            newUser = new User(res.data.user[0]);
                            if(data.channel_doc.direct && typeof newUser != 'undefined'){
                              SessionManager.UpdateDirectMessageName(data.channel_doc.channel_id, newUser.username)
                            }
                            if(typeof newUser != 'undefined'){
                              SessionManager.addUsertoChannel(data.channel_doc.channel_id, newUser)
                            }
                        }
                    })
                } else {
                    // newUser will never be undefined
                    if(data.channel_doc.direct && typeof newUser != 'undefined'){
                        SessionManager.UpdateDirectMessageNameWithUserId(newUser.user_id, newUser.username)
                    }
                    if(typeof newUser != 'undefined'){
                        SessionManager.addUsertoChannel(data.channel_doc.channel_id, newUser)
                    }
                }


              }
            }
          }
        })

        /** User updated his profile pic  */
        serverBus.$on(VueSignals.SOCKET_USER_CHANGED, (data) => {
          if(data.event == VueSignals.SOCKET_USER_CHANGED) {
            UserApi.getUsers([data.data]).then(res => {
              if(res.data.result){
                let user = res.data.user[0];
                SessionManager.UpdateUser(res.data.user);
                // If channel with user exists, update the picture
                // Logged in user doesn't need this picture update
                if (user.image_doc && user.user_id != SessionManager.getLoggedInUserId()) {
                    let image_doc = '';
                    if(user.image_doc != null && typeof user.image_doc.valueb64 != 'undefined'){
                        image_doc = "data"+user.image_doc.mimetype+";base64," + user.image_doc.valueb64
                        if(user.image_doc.mimetype.indexOf(":")== -1){
                            image_doc = "data:"+user.image_doc.mimetype+";base64," + user.image_doc.valueb64
                        }
                    }
                    SessionManager.updateDirectChannelPicture(user.user_id, image_doc);
                }
              }
            })
          }
        })
    }
}
